import "../assets/styles/views/pills-list.scss";
import { useEffect, useState } from "react";
import { useLocation, useOutletContext } from "react-router-dom";
import PillCard from "../components/PillCard";
import ChartBar from "../assets/icons/chart-bar";
import BackArrowButton from "../components/BackArrowButton";
import FullScreen from "../assets/icons/full-screen";
import { container, container_by_pv } from "../utils/endpoints";
import { getCookie } from "../utils/cookie";
import PageUnload from "../components/modal-contents/PageUnload";

export default function PillsList() {
  const [context, setContext] = useOutletContext();
  const [container_showed, setContainerShowed] = useState();
  const [current_pill, setCurrentPill] = useState();
  const [frame_url, setFrameUrl] = useState();
  const [completed_count, setCompletedCount] = useState(0);
  const [total_count, setTotalCount] = useState(0);
  const [frame_full_screen, setFrameFullScreen] = useState(false);
  const [offset_full_screen, setOffsetFullScreen] = useState();
  const [frame_content_url, setFrameContentUrl] = useState();
  const location = useLocation();

  window.onmessage = function (e) {
    if (e.origin !== process.env.REACT_APP_MOODLE_BASE_URL) return;
    else {
      if (current_pill && e?.data?.completed) {
        if (context?.progress) {
          let pill_progress = [...context.progress];
          pill_progress.find((x) => {
            if (x.cmId.toString() === current_pill.assetIdentifier) {
              x.state = 1;
            }
          });
          setTimeout(() => {
            setContext({ progress: pill_progress });
          }, 3000);
        }
      }
    }
  };

  useEffect(() => {
    if (context.progress && container_showed) {
      let count = 0;
      let valid_pills_count = 0;

      container_showed.learningPills.map((item, index) => {
        if (item.assetIdentifier) {
          valid_pills_count++;

          let pill_progress = context.progress.find(
            (x) => x.cmId.toString() === item.assetIdentifier
          );
          if (pill_progress && pill_progress?.state > 0) count++;
        }
      });
      setTotalCount(valid_pills_count);
      setCompletedCount(count);
      localStorage.removeItem("last_container_viewed");
    }
  }, [context.progress, container_showed]);

  useEffect(() => {
    if (context.session && !context.progress)
      context.updateUserProgress(context);
  }, [context.session]);

  useEffect(() => {
    if (!!location && location.state) {
      setContainerShowed(location.state);
      if (location.state?.selected) setCurrentPill(location.state.selected);
    } else {
      const url = new URL(window.location.href);
      let container_id = url.searchParams.get("container");

      if (container_id && context.session) {
        const impersonate_pv = getCookie("pv_impersonate");
        (async () => {
          context.updateUserProgress(context);
          let response = await context.httpRequest(
            "get",
            impersonate_pv
              ? container_by_pv.replace("*", impersonate_pv)
              : container,
            null,
            context.session.token
          );

          if (response.result) {
            let container_obj = response.data.find(
              (x) => x.id === parseInt(container_id)
            );
            setContainerShowed(container_obj);
          }
        })();
      } else {
        localStorage.removeItem("last_container_viewed");
        context.navigateUrl("/");
      }
    }
  }, [location, context.session]);

  useEffect(() => {
    if (current_pill && container_showed) {
      setFrameContentUrl();
      let path_extension = null;

      if (current_pill?.type?.assetResourceType) {
        switch (current_pill.type.assetResourceType) {
          case "QUIZ":
            path_extension = "quiz";
            break;
          case "FEEDBACK":
            path_extension = "feedback";
            break;
          case "SCORM":
            path_extension = "scorm";
            break;
          default:
            path_extension = "resource";
            break;
        }
      }

      setFrameUrl(
        `${process.env.REACT_APP_MOODLE_BASE_URL}/q8auth/q8_sso.php?client_id=${
          process.env.REACT_APP_SSO_CLIENT_ID
        }&dest=${encodeURIComponent(
          `/mod/${path_extension}/view.php?id=${current_pill?.assetIdentifier}`
        )}&back_link=`
      );
    }
  }, [current_pill, container_showed]);

  const getOffesetFullscreen = (e) => {
    setOffsetFullScreen(`-${e.target.getBoundingClientRect().top - 60}px`);
  };

  return (
    <>
      <BackArrowButton
        func={
          frame_content_url
            ? () => {
                context.openModal(<PageUnload path="/" />);
              }
            : null
        }
        path="/"
      />
      <section className="w-100 px-md-3 pills-list d-flex">
        {container_showed ? (
          <>
            <div className="pills-list__info-message position-sticky m-3 mx-md-0 my-md-5">
              <div className="d-flex align-items-center">
                <h1 className="my-0 me-3">{container_showed.title}</h1>
                <ChartBar
                  size={40}
                  color="#ffffff"
                  className="ms-auto me-2"
                />{" "}
                <strong className="course-status">
                  {completed_count}/{total_count}
                </strong>
              </div>
            </div>

            <div className="pills-list__container-list mb-md-5 d-md-flex main-panel w-100">
              <div className="pills">
                {!!container_showed &&
                container_showed.learningPills.length > 0 ? (
                  container_showed.learningPills.map((item, index) => {
                    return (
                      <PillCard
                        key={index}
                        pill_info={item}
                        container_info={container_showed}
                        setCurrentPill={setCurrentPill}
                        context={context}
                        setContext={setContext}
                      />
                    );
                  })
                ) : !!container_showed &&
                  container_showed.learningPills.length === 0 ? (
                  <span className="d-block text-center my-5">
                    Nessun risultato da mostrare
                  </span>
                ) : null}
              </div>
              {context.device === "dk" ? (
                <div className="pills-content d-none d-md-block mx-auto w-100 ps-5 position-relative">
                  {current_pill ? (
                    <>
                      <h2 className="mt-0 mb-3">{current_pill.title}</h2>
                      {!frame_content_url ? (
                        <div
                          className="border mt-5 d-flex flex-column align-items-center justify-content-center overflow-hidden p-5"
                          style={{
                            width: "100%",
                          }}
                        >
                          <strong
                            className="mb-4 text-center"
                            style={{ lineHeight: 1.8 }}
                          >
                            Clicca su "Avvia contenuto" per visualizzare la
                            pillola formativa
                          </strong>

                          <button
                            className="fw-bold q8-blue-button p-3"
                            onClick={() => {
                              setFrameContentUrl(frame_url);
                              window.onbeforeunload = function (e) {
                                e = e || window.event;
                                if (e) {
                                  e.returnValue =
                                    "Sei sicuro di voler abbandonare la seguente pillola formativa?";
                                }
                                return "Sei sicuro di voler abbandonare la seguente pillola formativa?";
                              };
                            }}
                          >
                            Avvia contenuto
                          </button>
                        </div>
                      ) : (
                        <div
                          onLoad={(e) => getOffesetFullscreen(e)}
                          style={
                            frame_full_screen
                              ? {
                                  width: "100vw",
                                  height: "calc(100vh - 60px)",
                                  marginTop: 60,
                                  top: `calc(${
                                    offset_full_screen || 0
                                  } - 0.6rem)`,
                                  transform: "translateX(-50%)",
                                }
                              : null
                          }
                          className={`overflow-hidden ${
                            frame_full_screen
                              ? "position-fixed start-50"
                              : "position-relative"
                          }`}
                        >
                          <iframe
                            className="overflow-hidden"
                            style={
                              frame_full_screen
                                ? {
                                    width: "100vw",
                                    height: "calc(100vh - 60px)",
                                  }
                                : { width: "100%", aspectRatio: "16/9" }
                            }
                            src={frame_content_url}
                          ></iframe>

                          <FullScreen
                            className="position-absolute full-screen-button p-1"
                            size={26}
                            color="#ffffff"
                            onClick={() =>
                              setFrameFullScreen(!frame_full_screen)
                            }
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    <h2 className="text-center">Seleziona un contenuto</h2>
                  )}
                </div>
              ) : null}
            </div>
          </>
        ) : null}
      </section>
    </>
  );
}
